document.addEventListener("DOMContentLoaded", async function () {
  const storyPagesContainer = document.getElementById("story-pages");

  const selectedGender = (await loadProfile())?.gender;
  const childName = (await loadProfile())?.name;

  console.log(selectedGender, childName)

  if (!selectedGender || !childName) {
    window.location.replace("/pages/personalise-book");
    return;
  }

  // const withProxy = (url) => `https://corsproxy.io/?${encodeURIComponent(url)}`;
  const withProxy = (url) => url;

  // Child Images (Max 10, Cycles if Name is Long)
  const childImages = {
    BOY: [
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_01.png?v=1747748480",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_02.png?v=1747748480",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_03.png?v=1747748480",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_04.png?v=1747748479",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_05.png?v=1747748480",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_06.png?v=1747748480",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_07.png?v=1747748480",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_08.png?v=1747748479",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_09.png?v=1747748480",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Left_10.png?v=1747748479",
    ],
    GIRL: [
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_01.png?v=1747747274",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_02.png?v=1747747278",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_03.png?v=1747747282",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_04.png?v=1747747286",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_05.png?v=1747747289",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_06.png?v=1747747290",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_07.png?v=1747747293",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_08.png?v=1747747294",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_09.png?v=1747747297",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Left_10.png?v=1747747297",
    ],
  };

  const storyImages = {
    BOY: {
      A: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_A_01.png?v=1747821726",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_A_02.png?v=1747821725",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_A_03.png?v=1747821725",
      ],
      a_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_a_01.png?v=1747822314",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_a_02.png?v=1747822314",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_a_03.png?v=1747822314",
      ],
      a_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_a_01.png?v=1747822722",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_a_02.png?v=1747822723",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_a_03.png?v=1747822722",
      ],
      a_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_a_01.png?v=1747822989",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_a_02.png?v=1747822989",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_a_03.png?v=1747822989",
      ],
      B: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_B_01.png?v=1747823162",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_B_02.png?v=1747823162",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_B_03.png?v=1747823162",
      ],
      b_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_b_01.png?v=1751039501",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_b_02.png?v=1751039495",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_b_03.png?v=1751039501",
      ],
      b_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_b_01.png?v=1751036208",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_b_02.png?v=1751036209",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_b_03.png?v=1751036209",
      ],
      C: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_C_01.png?v=1747823503",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_C_02.png?v=1747823503",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_C_03.png?v=1747823503",
      ],
      c_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_c_01.png?v=1747823644",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_c_02.png?v=1747823644",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_c_03.png?v=1747823644",
      ],
      c_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_c_01.png?v=1747823813",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_c_02.png?v=1747823814",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_c_03.png?v=1747823814",
      ],
      D: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_D_01.png?v=1747824004",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_D_02.png?v=1747824004",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_D_03.png?v=1747824004",
      ],
      d_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_d_01.png?v=1747824165",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_d_02.png?v=1747824166",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_d_03.png?v=1747824166",
      ],
      d_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_d_01.png?v=1747824325",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_d_02.png?v=1747824325",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_d_03.png?v=1747824326",
      ],
      E: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_E_01.png?v=1747824507",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_E_02.png?v=1747824507",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_E_03.png?v=1747824507",
      ],
      e_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_e_01.png?v=1747824651",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_e_02.png?v=1747824652",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_e_03.png?v=1747824652",
      ],
      e_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_e_01.png?v=1747824781",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_e_02.png?v=1747824781",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_e_03.png?v=1747824781",
      ],
      e_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_e_01.png?v=1747824922",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_e_02.png?v=1747824923",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_e_03.png?v=1747824923",
      ],
      F: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_F_01.png?v=1747825060",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_F_02.png?v=1747825061",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_F_03.png?v=1747825061",
      ],
      f_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_f_01.jpg?v=1751035918",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_f_02.jpg?v=1751035922",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_f_03.jpg?v=1751035931",
      ],
      f_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_f_01.png?v=1751036006",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_f_02.png?v=1751036006",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_f_03.png?v=1751036006",
      ],
      G: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_G_01.png?v=1747825410",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_G_02.png?v=1747825410",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_G_03.png?v=1747825410",
      ],
      g_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_g_01.png?v=1747825528",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_g_02.png?v=1747825528",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_g_03.png?v=1747825529",
      ],
      H: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_H_01.png?v=1747826412",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_H_02.png?v=1747826413",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_H_03.png?v=1747826413",
      ],
      h_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_h_01.png?v=1747826568",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_h_02.png?v=1747826568",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_h_03.png?v=1747826568",
      ],
      h_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_h_01.png?v=1747826727",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_h_02.png?v=1747826728",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_h_03.png?v=1747826729",
      ],
      I: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_I_01.png?v=1747826978",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_I_02.png?v=1747826978",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/3BabyLetters.png?v=1753192684",
      ],
      i_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_i_01.png?v=1747827113",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_i_02.png?v=1747827114",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_i_03.png?v=1747827114",
      ],
      i_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_i_01.png?v=1747827248",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_i_02.png?v=1747827249",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_i_03.png?v=1747827249",
      ],
      J: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_J_01.png?v=1747827432",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_J_02.png?v=1747827432",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_J_03.png?v=1747827433",
      ],
      j_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_j_01.png?v=1747827534",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_J_02.png?v=1747827432",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_J_03.png?v=1747827433",
      ],
      K: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_K_01.png?v=1747827654",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_K_02.png?v=1747827654",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_K_03.png?v=1747827655",
      ],
      k_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_k_01.png?v=1747827767",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_K_02.png?v=1747827654",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_K_03.png?v=1747827655",
      ],
      L: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_L_01.png?v=1747828291",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_L_02.png?v=1747828292",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_L_03.png?v=1747828291",
      ],
      l_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_l_01.png?v=1747828441",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_l_02.png?v=1747828442",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_l_03.png?v=1747828441",
      ],
      l_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_l_01.png?v=1747828604",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_l_02.png?v=1747828604",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_l_03.png?v=1747828604",
      ],
      M: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_M_01.png?v=1747828994",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_M_02.png?v=1747828995",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_M_03.png?v=1747828995",
      ],
      m_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_m_01.png?v=1747829108",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_m_02.png?v=1747829108",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_m_03.png?v=1747829108",
      ],
      m_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_m_01.png?v=1747829231",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_m_02.png?v=1747829232",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_m_03.png?v=1747829232",
      ],
      N: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_N_01.png?v=1747829382",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_N_02.png?v=1747829382",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_N_03.png?v=1747829382",
      ],
      n_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_n_01.png?v=1747829566",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_n_02.png?v=1747829567",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_n_03.png?v=1747829567",
      ],
      n_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_n_01.png?v=1747829684",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_n_02.png?v=1747829685",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_n_03.png?v=1747829686",
      ],
      n_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_n_01.png?v=1747829858",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_n_02.png?v=1747829859",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_n_03.png?v=1747829859",
      ],
      O: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_O_01.png?v=1747830007",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_O_02.png?v=1747830008",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_O_03.png?v=1747830008",
      ],
      o_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_o_01.png?v=1747830141",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_o_02.png?v=1747830141",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_o_03.png?v=1747830141",
      ],
      o_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_o_01.png?v=1747830262",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_o_02.png?v=1747830262",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_o_03.png?v=1747830262",
      ],
      P: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_P_01.png?v=1747830435",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_P_02.png?v=1747830436",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_P_03.png?v=1747830436",
      ],
      p_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_p_01.png?v=1747830589",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_p_02.png?v=1747830589",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_p_03.png?v=1747830590",
      ],
      Q: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Q_01.png?v=1747830764",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Q_02.png?v=1747830765",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Q_03.png?v=1747830765",
      ],
      q_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_q_01.png?v=1747830909",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Q_02.png?v=1747830765",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Q_03.png?v=1747830765",
      ],
      R: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_R_01.png?v=1747831116",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_R_02.png?v=1747831116",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_R_03.png?v=1747831116",
      ],
      r_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_r_01.png?v=1747832743",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_r_02.png?v=1747832743",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_r_03.png?v=1747832744",
      ],
      r_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_r_01.png?v=1747833996",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_r_02.png?v=1747833997",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_r_03.png?v=1747833997",
      ],
      r_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_r_01.png?v=1747834112",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_r_02.png?v=1747834113",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_r_03.png?v=1747834113",
      ],
      S: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_S_01.png?v=1747834248",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_S_02.png?v=1747834249",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_S_03.png?v=1747834248",
      ],
      s_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_s_01.png?v=1747834442",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_s_02.png?v=1747834443",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_s_03.png?v=1747834443",
      ],
      s_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_s_01.png?v=1747834580",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_s_02.png?v=1747834580",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_s_03.png?v=1747834579",
      ],
      s_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_s_01.png?v=1747834727",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_s_02.png?v=1747834727",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Third_s_03.png?v=1747834727",
      ],
      T: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_T_01.png?v=1747834864",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_T_02.png?v=1747834864",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_T_03.png?v=1747834864",
      ],
      t_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_t_01.png?v=1747834994",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_t_02.png?v=1747834995",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_t_03.png?v=1747834995",
      ],
      U: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_U_01.png?v=1747835115",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_U_02.png?v=1747835115",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_U_03.png?v=1747835116",
      ],
      u_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_u_01.jpg?v=1751035745",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_u_02.jpg?v=1751035746",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_u_03.jpg?v=1751035746",
      ],
      u_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_u_01.png?v=1751035814",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_u_02.png?v=1751035814",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_Second_u_03.png?v=1751035815",
      ],
      V: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_V_01.png?v=1747835350",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_V_02.png?v=1747835350",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_V_03.png?v=1747835350",
      ],
      v_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_v_01.png?v=1747835440",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_V_02.png?v=1747835350",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_V_03.png?v=1747835350",
      ],
      W: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_W_01.png?v=1747835562",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_W_02.png?v=1747835563",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_W_03.png?v=1747835563",
      ],
      w_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_w_01.png?v=1747835658",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_W_02.png?v=1747835563",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_W_03.png?v=1747835563",
      ],
      X: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_X_01.png?v=1747835794",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_X_02.png?v=1747835795",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_X_03.png?v=1747835796",
      ],
      x_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_x_01.png?v=1747835887",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_X_02.png?v=1747835795",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_X_03.png?v=1747835796",
      ],
      Y: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Y_01.png?v=1747836021",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Y_02.png?v=1747836020",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Y_03.png?v=1747836020",
      ],
      y_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_y_01.png?v=1747836108",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Y_02.png?v=1747836020",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Y_03.png?v=1747836020",
      ],
      Z: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Z_01.png?v=1747836220",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Z_02.png?v=1747836219",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Z_03.png?v=1747836219",
      ],
      z_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Small_Letter_First_z_01.png?v=1747836322",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Z_02.png?v=1747836219",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Capital_Letter_Z_03.png?v=1747836219",
      ],
    },
    GIRL: {
      A: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_A_01.png?v=1747836897",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_A_02.png?v=1747836896",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_A_03.png?v=1747836896",
      ],
      a_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_a_01.png?v=1747837033",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_a_02.png?v=1747837033",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_a_03.png?v=1747837033",
      ],
      a_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_a_01.png?v=1747837207",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_a_02.png?v=1747837208",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_a_03.png?v=1747837208",
      ],
      a_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_a_01.png?v=1747837389",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_a_02.png?v=1747837389",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_a_03.png?v=1747837390",
      ],
      B: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_B_01.png?v=1747837952",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_B_02.png?v=1747837953",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_B_03.png?v=1747837953",
      ],
      b_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/1HeBabyLetters.png?v=1753192683",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_b_02.jpg?v=1751035562",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_b_03.jpg?v=1751035562",
      ],
      b_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_b_01.png?v=1751035638",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_b_02.png?v=1751035639",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_b_03.png?v=1751035639",
      ],
      C: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_C_01.png?v=1747838537",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_C_02.png?v=1747838537",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_C_03.png?v=1747838538",
      ],
      c_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_c_01.png?v=1747838831",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_c_02.png?v=1747838832",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_c_03.png?v=1747838831",
      ],
      c_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_c_01.png?v=1747839229",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_c_02.png?v=1747839230",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_c_03.png?v=1747839229",
      ],
      D: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_D_01.png?v=1747840133",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_D_02.png?v=1747840134",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_D_03.png?v=1747840134",
      ],
      d_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_d_01.png?v=1747840436",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_d_02.png?v=1747840437",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_d_03.png?v=1747840437",
      ],
      d_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_d_01.png?v=1747840715",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_d_02.png?v=1747840715",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_d_03.png?v=1747840715",
      ],
      E: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_E_01.png?v=1747895280",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_E_02.png?v=1747895281",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_E_03.png?v=1747895280",
      ],
      e_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_e_01.png?v=1747896537",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_e_02.png?v=1747896538",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_e_03.png?v=1747896539",
      ],
      e_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_e_01.png?v=1747896915",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_e_02.png?v=1747896915",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_e_03.png?v=1747896917",
      ],
      e_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_e_01.png?v=1747897134",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_e_02.png?v=1747897135",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_e_03.png?v=1747897134",
      ],
      F: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_F_01.png?v=1747898360",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_F_02.png?v=1747898361",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_F_03.png?v=1747898361",
      ],
      f_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_f_01.jpg?v=1751035353",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_f_02.jpg?v=1751035354",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_f_03.jpg?v=1751035353",
      ],
      f_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_f_01.png?v=1751035445",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_f_02.png?v=1751035445",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_f_03.png?v=1751035445",
      ],
      G: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_G_01.png?v=1747899015",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_G_02.png?v=1747899015",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_G_03.png?v=1747899015",
      ],
      g_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_g_01.png?v=1747899167",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_g_02.png?v=1747899167",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_g_03.png?v=1747899168",
      ],
      H: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_H_01.png?v=1747899306",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_H_02.png?v=1747899307",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_H_03.png?v=1747899307",
      ],
      h_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_h_01.png?v=1747899481",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_h_02.png?v=1747899482",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_h_03.png?v=1747899482",
      ],
      h_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_h_01.png?v=1747899610",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_h_02.png?v=1747899610",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_h_03.png?v=1747899611",
      ],
      I: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_I_01.png?v=1747899817",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_I_02.png?v=1747899818",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_I_03.png?v=1747899818",
      ],
      i_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_i_01.png?v=1747899952",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_i_02.png?v=1747899953",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_i_03.png?v=1747899953",
      ],
      i_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_i_01.png?v=1747900086",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_i_02.png?v=1747900087",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_i_03.png?v=1747900086",
      ],
      J: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_J_01.png?v=1747900250",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_J_02.png?v=1747900250",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_J_03.png?v=1747900250",
      ],
      j_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_j_01.png?v=1747900345",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_J_02.png?v=1747900250",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_J_03.png?v=1747900250",
      ],
      K: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_K_01.png?v=1747900580",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_K_02.png?v=1747900580",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_K_03.png?v=1747900581",
      ],
      k_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_k_01.png?v=1747900708",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_K_02.png?v=1747900580",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_K_03.png?v=1747900581",
      ],
      L: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_L_01.png?v=1747900847",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_L_02.png?v=1747900847",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_L_03.png?v=1747900848",
      ],
      l_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_l_01.png?v=1747901037",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_l_02.png?v=1747901036",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_l_03.png?v=1747901037",
      ],
      l_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_l_01.png?v=1747901167",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_l_02.png?v=1747901167",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_l_03.png?v=1747901167",
      ],
      M: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_M_01.png?v=1747905694",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_M_02.png?v=1747905694",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_M_03.png?v=1747905694",
      ],
      m_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_m_01.png?v=1747905852",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_m_02.png?v=1747905853",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_m_03.png?v=1747905852",
      ],
      m_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_m_01.png?v=1747905978",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_m_02.png?v=1747905978",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_m_03.png?v=1747905979",
      ],
      N: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_N_01.png?v=1747906194",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_N_02.png?v=1747906194",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_N_03.png?v=1747906194",
      ],
      n_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_n_01.png?v=1747906330",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_n_02.png?v=1747906331",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_n_03.png?v=1747906331",
      ],
      n_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_n_01.png?v=1747906457",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_n_02.png?v=1747906457",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_n_03.png?v=1747906457",
      ],
      n_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_n_01.png?v=1747906576",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_n_02.png?v=1747906575",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_n_03.png?v=1747906575",
      ],
      O: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_O_01.png?v=1747906721",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_O_02.png?v=1747906722",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_O_03.png?v=1747906721",
      ],
      o_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_o_01.png?v=1747906856",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_o_02.png?v=1747906856",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_o_03.png?v=1747906857",
      ],
      o_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_o_01.png?v=1747908132",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_o_02.png?v=1747908132",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_o_03.png?v=1747908133",
      ],
      P: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_P_01.png?v=1747908534",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_P_02.png?v=1747908534",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_P_03.png?v=1747908534",
      ],
      p_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_p_01.png?v=1747908708",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_p_02.png?v=1747908708",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_p_03.png?v=1747908708",
      ],
      Q: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Q_01.png?v=1747908830",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Q_02.png?v=1747908831",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Q_03.png?v=1747908831",
      ],
      q_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_q_01.png?v=1747908926",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Q_02.png?v=1747908831",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Q_03.png?v=1747908831",
      ],
      R: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_R_01.png?v=1747909116",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_R_02.png?v=1747909116",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_R_03.png?v=1747909117",
      ],
      r_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_r_01.png?v=1747909273",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_r_02.png?v=1747909273",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_r_03.png?v=1747909273",
      ],
      r_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_r_01.png?v=1747909452",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_r_02.png?v=1747909453",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_r_03.png?v=1747909453",
      ],
      r_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_r_01.png?v=1747909566",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_r_02.png?v=1747909567",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_r_03.png?v=1747909567",
      ],
      S: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_S_01.png?v=1747909685",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_S_02.png?v=1747909685",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_S_03.png?v=1747909685",
      ],
      s_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_s_01.png?v=1747909820",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_s_02.png?v=1747909820",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_s_03.png?v=1747909821",
      ],
      s_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_s_01.png?v=1747910109",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_s_02.png?v=1747910109",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_s_03.png?v=1747910109",
      ],
      s_3: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_s_01.png?v=1747910299",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_s_02.png?v=1747910300",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Third_s_03.png?v=1747910300",
      ],
      T: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_T_01.png?v=1747910509",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_T_02.png?v=1747910507",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_T_03.png?v=1747910509",
      ],
      t_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_t_01.png?v=1747910628",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_t_02.png?v=1747910629",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_t_03.png?v=1747910630",
      ],
      U: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_U_01.png?v=1747910786",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_U_02.png?v=1747910786",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_U_03.png?v=1747910787",
      ],
      u_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_u_01.jpg?v=1751035149",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_u_02.jpg?v=1751035149",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_u_03.jpg?v=1751035150",
      ],
      u_2: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_u_01.png?v=1751035238",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_u_02.png?v=1751035239",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_Second_u_03.png?v=1751035239",
      ],
      V: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_V_01.png?v=1747911019",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_V_02.png?v=1747911018",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_V_03.png?v=1747911019",
      ],
      v_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_v_01.png?v=1747911103",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_V_02.png?v=1747911018",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_V_03.png?v=1747911019",
      ],
      W: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_W_01.png?v=1747911217",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_W_02.png?v=1747911218",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_W_03.png?v=1747911217",
      ],
      w_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_w_01.png?v=1747911304",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_W_02.png?v=1747911218",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_W_03.png?v=1747911217",
      ],
      x: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_X_01.png?v=1747911408",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_X_02.png?v=1747911409",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_X_03.png?v=1747911408",
      ],
      x_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_x_01.png?v=1747911491",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_X_02.png?v=1747911409",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_X_03.png?v=1747911408",
      ],
      Y: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Y_01.png?v=1747912716",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Y_02.png?v=1747912716",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Y_03.png?v=1747912716",
      ],
      y_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_y_01.png?v=1747912870",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Y_02.png?v=1747912716",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Y_03.png?v=1747912716",
      ],
      Z: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Z_01.png?v=1747913014",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Z_02.png?v=1747913014",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Z_03.png?v=1747913015",
      ],
      z_1: [
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Small_Letter_First_z_01.png?v=1747913099",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Z_02.png?v=1747913014",
        "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Capital_Letter_Z_03.png?v=1747913015",
      ],
    },
  };

  const hangingAssets = {
    string:
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/String.png?v=1744787435",
    starsWithString:
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Stars_With_String.png?v=1744787437",
    letters: {
      A: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_A.png?v=1744788968",
      a_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_a.png?v=1744788968",
      a_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_a.png?v=1744788969",
      a_3: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Third_a.png?v=1744788969",
      B: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_B.png?v=1744956842",
      b_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_b.png?v=1744956841",
      b_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_b.png?v=1744956841",
      C: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_C.png?v=1744957536",
      c_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_c.png?v=1744957535",
      c_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_c.png?v=1744957535",
      D: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_D.png?v=1744958360",
      d_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_d.png?v=1744958360",
      d_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_d.png?v=1744958360",
      E: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_E.png?v=1744958932",
      e_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_e.png?v=1744958933",
      e_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_e.png?v=1744958933",
      e_3: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Third_e.png?v=1744958932",
      F: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_F.png?v=1744959346",
      f_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_f.png?v=1744959347",
      f_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_f.png?v=1744959347",
      G: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_G.png?v=1744959709",
      g_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_g.png?v=1744959709",
      H: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_H.png?v=1744960632",
      h_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_h.png?v=1744960632",
      h_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_h.png?v=1744960633",
      I: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_I.png?v=1746179286",
      i_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_i.png?v=1746184948",
      i_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_i.png?v=1746185044",
      J: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_J.png?v=1744968232",
      j_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_j.png?v=1745216907",
      K: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_K.png?v=1745215659",
      k_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_k.png?v=1745215661",
      L: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_L.png?v=1745216224",
      l_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_l.png?v=1746184784",
      l_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_l.png?v=1746184785",
      M: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_M.png?v=1744875775",
      m_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_m.png?v=1744875775",
      m_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_m.png?v=1744875775",
      N: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_N.png?v=1745217566",
      n_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_n.png?v=1745217565",
      n_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_n.png?v=1745217566",
      n_3: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Third_n.png?v=1745217565",
      O: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_O.png?v=1745218027",
      o_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_o.png?v=1745218026",
      o_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_o.png?v=1745218027",
      o_3: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Third_o.png?v=1745218028",
      P: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_P.png?v=1745218397",
      p_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_p.png?v=1745218397",
      Q: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_Q.png?v=1745222673",
      q_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_q.png?v=1745222671",
      R: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_R.png?v=1745223520",
      r_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_r.png?v=1745223519",
      r_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_r.png?v=1745223518",
      r_3: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Third_r.png?v=1745223517",
      S: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_S.png?v=1745224055",
      s_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_s.png?v=1745224054",
      s_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Second_s.png?v=1745224054",
      s_3: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_Third_s.png?v=1745224055",
      T: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_T.png?v=1745225867",
      t_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_t.png?v=1745225869",
      U: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_U.png?v=1745226130",
      u_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_u.png?v=1745226131",
      u_2: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_u.png?v=1745226131",
      V: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_V.png?v=1745226374",
      v_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_v.png?v=1745226374",
      W: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_W.png?v=1745226720",
      w_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_w.png?v=1745226719",
      X: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_X.png?v=1745226974",
      x_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_x.png?v=1745226973",
      Y: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_Y.png?v=1745227222",
      y_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_y.png?v=1745227222",
      Z: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Capital_Letter_Z.png?v=1744876695",
      z_1: "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Small_Letter_First_z.png?v=1744876696",
    },
  };

  const usedLowerVariants = {};
  const hangingLetterData = [];
  let childImageIndex = 0;
  let imageCount = 0;
  let letterIndex = 0;

  function createWrappedImage(src, imageClass) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("story-page");

    const sideClass =
      imageCount % 2 === 0 ? "story-page-left" : "story-page-right";
    wrapper.classList.add(sideClass);

    const img = document.createElement("img");
    img.src = src;
    img.classList.add("story-grid-item", imageClass);
    wrapper.appendChild(img);

    imageCount++;
    return wrapper;
  }

  async function createChildImageWithCanvas(
    baseImageSrc,
    letterIndex,
    isLastLetter = false
  ) {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.classList.add("child-image-canvas");
      canvas.width = 580;
      canvas.height = 580;
      const ctx = canvas.getContext("2d");

      // Local helper to make the canvas high resolution
      function setupHighResCanvas(canvas, ctx, scaleFactor = 4.4) {
        const displayWidth = canvas.width;
        const displayHeight = canvas.height;

        canvas.width = displayWidth * scaleFactor;
        canvas.height = displayHeight * scaleFactor;
        canvas.style.width = displayWidth + "px";
        canvas.style.height = displayHeight + "px";

        ctx.scale(scaleFactor, scaleFactor);
      }

      // Apply high-res scaling before drawing anything
      // setupHighResCanvas(canvas, ctx);

      const wrapper = document.createElement("div");
      wrapper.classList.add(
        "story-page",
        imageCount % 2 === 0 ? "story-page-left" : "story-page-right"
      );
      wrapper.appendChild(canvas);
      imageCount++;

      const baseImg = new Image();
      baseImg.crossOrigin = "anonymous";
      baseImg.src = withProxy(baseImageSrc);

      baseImg.onload = async () => {
        ctx.drawImage(baseImg, 0, 0, 580, 580); // Draw at original size, scaled behind-the-scenes

        const maxLetters = 10;
        const startX = 40;
        const endX = 580 - startX;
        const availableWidth = endX - startX;

        const leftHangingCapitals = [
          "M",
          "N",
          "K",
          "H",
          "L",
          "U",
          "V",
          "W",
          "X",
          "Y",
        ];
        const leftHangingSmalls = [
          "b",
          "d",
          "h",
          "k",
          "m",
          "n",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
        ];
        const wideLetters = ["W", "M", "w", "m"];

        const items = [];

        const lettersToShow = hangingLetterData.slice(0, letterIndex + 1);
        const numStars = Math.max(0, 2 - letterIndex);

        const dynamicLetterWidth = (char) => {
          const isCapital = char === char.toUpperCase();
          const isWide = wideLetters.includes(char);
          const base = isCapital ? 70 : 40;
          const extra = isWide ? 20 : 0;
          const scale = Math.min(1, maxLetters / hangingLetterData.length);
          return Math.max(30, base * scale + extra);
        };

        for (const letterObj of lettersToShow) {
          const char = letterObj.letter;
          const isCapital = char === char.toUpperCase();
          const isLeftHanging = isCapital
            ? leftHangingCapitals.includes(char)
            : leftHangingSmalls.includes(char.toLowerCase());

          const width = dynamicLetterWidth(char);

          items.push({
            type: "letter",
            letter: letterObj,
            width,
            isLeftHanging,
          });
        }

        for (let i = 0; i < numStars; i++) {
          items.unshift({ type: "star", width: 50 });
        }

        const totalWidth = items.reduce((sum, item) => sum + item.width, 0);
        const minSpacing = 10;
        const maxSpacing = 30;
        const spacing = Math.min(
          maxSpacing,
          Math.max(
            minSpacing,
            (availableWidth - totalWidth) / (items.length - 1 || 1)
          )
        );

        const totalUsedWidth = totalWidth + (items.length - 1) * spacing;
        const startPosition = startX + (availableWidth - totalUsedWidth) / 2;

        const starImg = await loadImage(
          withProxy(hangingAssets.starsWithString)
        );
        const stringImg = await loadImage(withProxy(hangingAssets.string));

        let currentX = startPosition;
        for (const item of items) {
          if (item.type === "letter") {
            const { letter, width, isLeftHanging } = item;
            const letterImg = await loadImage(withProxy(letter.src));
            const stringWidth = 2;
            const stringHeight = 150;

            let stringX = currentX + (width - stringWidth) / 2;
            if (isLeftHanging) {
              stringX = currentX;
            }

            ctx.drawImage(stringImg, stringX, 0, stringWidth, stringHeight);

            const tiltAngle = isLeftHanging ? -0.1 : 0.1;
            const letterTop = stringHeight - 5;

            ctx.save();
            ctx.translate(
              currentX + width / 2,
              letterTop + width / (letterImg.width / letterImg.height) / 2
            );
            ctx.rotate(tiltAngle);
            ctx.drawImage(
              letterImg,
              -width / 2,
              -(width / (letterImg.width / letterImg.height)) / 2,
              width,
              width / (letterImg.width / letterImg.height)
            );
            ctx.restore();

            currentX += width + spacing;
          } else {
            ctx.drawImage(
              starImg,
              currentX - 25,
              0,
              50,
              starImg.height * (50 / starImg.width)
            );
            currentX += 50 + spacing;
          }
        }

        resolve(wrapper);
      };
    });
  }

  // function loadImage(src) {
  //   return new Promise((resolve) => {
  //     const img = new Image();
  //     img.crossOrigin = "anonymous";
  //     img.src = src;
  //     img.onload = () => resolve(img);
  //   });
  // }

  const imageCache = {};

  function loadImage(src) {
    return new Promise((resolve) => {
      if (imageCache[src]) {
        resolve(imageCache[src]);
      } else {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = src;
        img.onload = () => {
          imageCache[src] = img;
          resolve(img);
        };
      }
    });
  }

  async function processName() {
    const nameLetters = Array.from(childName).filter((char) =>
      char.match(/[a-zA-Z]/)
    );

    for (let i = 0; i < nameLetters.length; i++) {
      const char = nameLetters[i];
      const isLastLetter = i === nameLetters.length - 1;
      const isCapital = char === char.toUpperCase();
      const lowerChar = char.toLowerCase();
      const upperChar = char.toUpperCase();

      let letterSrc = null;

      // Capital letter logic
      // if (isCapital && storyImages[selectedGender][upperChar]) {
      //   const images = storyImages[selectedGender][upperChar];
      //   images.slice(1).forEach((src) => {
      //     const wrapped = createWrappedImage(src, "story-image");
      //     storyPagesContainer.appendChild(wrapped);
      //   });

      //   const childCanvas = await createChildImageWithCanvas(
      //     childImages[selectedGender][
      //       childImageIndex % childImages[selectedGender].length
      //     ],
      //     letterIndex,
      //     isLastLetter
      //   );
      //   storyPagesContainer.appendChild(childCanvas);
      //   childImageIndex++;

      //   const letterImg = createWrappedImage(images[0], "letter-image");
      //   storyPagesContainer.appendChild(letterImg);

      //   letterSrc = hangingAssets.letters[upperChar];
      if (isCapital && storyImages[selectedGender][upperChar]) {
        const images = storyImages[selectedGender][upperChar];

        letterSrc = hangingAssets.letters[upperChar];
        await loadImage(letterSrc); // cache preload
        hangingLetterData.push({ letter: char, src: letterSrc });

        for (const src of images.slice(1)) {
          await loadImage(src); // cache preload
          const wrapped = createWrappedImage(src, "story-image");
          storyPagesContainer.appendChild(wrapped);
        }

        const childCanvas = await createChildImageWithCanvas(
          childImages[selectedGender][
            childImageIndex % childImages[selectedGender].length
          ],
          letterIndex,
          isLastLetter
        );
        storyPagesContainer.appendChild(childCanvas);
        childImageIndex++;

        await loadImage(images[0]); // cache preload
        const letterImg = createWrappedImage(images[0], "letter-image");
        storyPagesContainer.appendChild(letterImg);
      } else {
        // Small letter logic
        usedLowerVariants[lowerChar] = (usedLowerVariants[lowerChar] || 0) + 1;
        const variantKey = `${lowerChar}_${usedLowerVariants[lowerChar]}`;
        const images = storyImages[selectedGender][variantKey];
        // if (images) {
        //   images.slice(1).forEach((src) => {
        //     const wrapped = createWrappedImage(src, "story-image");
        //     storyPagesContainer.appendChild(wrapped);
        //   });

        //   const childCanvas = await createChildImageWithCanvas(
        //     childImages[selectedGender][
        //       childImageIndex % childImages[selectedGender].length
        //     ],
        //     letterIndex,
        //     isLastLetter
        //   );
        //   storyPagesContainer.appendChild(childCanvas);
        //   childImageIndex++;

        //   const letterImg = createWrappedImage(images[0], "letter-image");
        //   storyPagesContainer.appendChild(letterImg);

        //   letterSrc = hangingAssets.letters[variantKey];
        // }
        if (images) {
          letterSrc = hangingAssets.letters[variantKey];
          await loadImage(letterSrc); // cache preload
          hangingLetterData.push({ letter: char, src: letterSrc });

          for (const src of images.slice(1)) {
            await loadImage(src); // cache preload
            const wrapped = createWrappedImage(src, "story-image");
            storyPagesContainer.appendChild(wrapped);
          }

          const childCanvas = await createChildImageWithCanvas(
            childImages[selectedGender][
              childImageIndex % childImages[selectedGender].length
            ],
            letterIndex,
            isLastLetter
          );
          storyPagesContainer.appendChild(childCanvas);
          childImageIndex++;

          await loadImage(images[0]); // cache preload
          const letterImg = createWrappedImage(images[0], "letter-image");
          storyPagesContainer.appendChild(letterImg);
        }
      }

      letterIndex++;
    }
  }

  processName();
});
